// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const hatterene: PokeData = {
  "id": 858,
  "name": "hatterene",
  "height": 21,
  "weight": 51,
  "base_experience": 255,
  "types": [
    PokeType.PSYCHIC,
    PokeType.FAIRY
  ],
  "api_moves": [
    "psybeam",
    "confusion",
    "psychic",
    "aromatherapy",
    "calm-mind",
    "healing-wish",
    "psycho-cut",
    "heal-pulse",
    "disarming-voice",
    "play-nice",
    "aromatic-mist",
    "dazzling-gleam",
    "brutal-swing",
    "magic-powder",
    "life-dew"
  ],
  "moves": [
    "psychic",
    "aromatherapy",
    "calm-mind",
    "healing-wish",
    "dazzling-gleam",
    "life-dew",
    "zen-headbutt",
    "guardian-bond",
    "psy-pulse",
    "psywave",
    "moonblast",
    "reflect",
    "future-sight"
  ],
  "evolution_chain": {
    "id": 450,
    "item": null,
    "species": [
      {
        "name": "hatenna",
        "order": 856,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "hattrem",
        "order": 857,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 856,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 32,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "hatterene",
        "order": 858,
        "types": [
          PokeType.PSYCHIC,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 857,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 42,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 128,
    "speed": 48,
    "ability_power": 224
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
